import { BaseModel } from "@/models/BaseModel";
import { maxLength, required } from "vuelidate/lib/validators";
import { User } from "@/models/User";
export class WhistleblowerComment extends BaseModel {
  constructor({ message, user, time, report }) {
    super();
    this.message = message;
    this.user = user ? new User(user) : null;
    this.time = time;
    this.report = report;
  }
  static get validations() {
    return validations;
  }
}

export default WhistleblowerComment;
